import { gql } from '@apollo/client'

export const VAULTS_QUERY = gql`
  query ($owner: String) {
    vaultEntities(where: { owner: $owner, isClosed: false }, orderBy: vaultId) {
      id
      vaultId
      owner
      margin
      isMainVault
      openPositions {
        id
        assetId
        perpUpdatedAt
        squartUpdatedAt
        createdAt
        updatedAt
      }
    }
  }
`

export type VaultEntities = {
  vaultEntities: {
    id: string
    vaultId: string
    owner: string
    margin: string
    isMainVault: boolean
    openPositions: {
      id: string
      assetId: string
      perpUpdatedAt: string
      squartUpdatedAt: string
      createdAt: string
      updatedAt: string
    }[]
  }[]
}
